import {mapGetters} from "vuex";
import {getActivityStatus} from "../studyActivity/activityStatus";

// Attention flags surfaced by both the top bar (a dot on the section) and the
// section submenu (a "Requires Attention" line on the item).
export default {
    data() {
        return {
            activityState: null
        };
    },
    computed: {
        ...mapGetters(['enrollments', 'registrations', 'certificatesLoaded', 'inProgressApplicationCount']),
        incompleteCourseApps() {
            if (!this.enrollments) return false;
            return this.enrollments.some(enrollment => (enrollment.isIncompleteApps && enrollment.completed_at));
        },
        incompleteConfApps() {
            if (!this.registrations) return false;
            return this.registrations.some(registration => registration.isIncompleteApps);
        },
        activityFlag() {
            if (this.activityState === 'audit_risk') return {text: 'Requires Attention', cls: 'has-text-danger'};
            if (this.activityState === 'elevated') return {text: 'Unusual Activity', cls: 'has-text-warning'};
            return null;
        },
        // section key -> flag class (warning/danger) or null
        sectionFlags() {
            return {
                courses: this.incompleteCourseApps ? 'has-text-warning' : null,
                conferences: this.incompleteConfApps ? 'has-text-warning' : null,
                records: this.activityFlag ? this.activityFlag.cls : null
            };
        }
    },
    mounted() {
        getActivityStatus().then(status => {
            this.activityState = status.state;
        });
        // Started-and-unfinished applications decide whether "In Progress
        // Applications" is in the Certificates & Forms menu; same endpoint
        // as that page (store module certificates)
        if (!this.certificatesLoaded) this.$store.dispatch('getCertificates').catch(() => {});
    }
};
